import React, { FC } from 'react';
import { IPaginatorProps } from './';
import ReactPaginate from 'react-paginate';
import { Icons } from '../Icon';
import { IconTemplate } from '../Icon/IconTemplate';

export const PaginatorTemplate: FC<IPaginatorProps> = ({ total, className, handlePageClick, page, perPage = 10 }) => {
    return (
        <div className={className}>
            <ReactPaginate
                previousLabel={<IconTemplate name={Icons.chevronLeftOutlined} />}
                nextLabel={<IconTemplate name={Icons.chevronRightOutlined} />}
                breakLabel={'...'}
                breakClassName={'break-me'}
                pageCount={total / perPage}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                activeClassName={'active'}
                forcePage={page - 1}
            />
        </div>
    );
};
